import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import mixpanel from 'mixpanel-browser';

import { getEmailReports, deleteRecurringEmail } from 'services/Views/thunks';
import { selectEmailReports } from 'services/Views/selectors';

import { getRevertedCronString } from 'utils';

import { TIME_TRANSLATIONS, FREQUENCY_TRANSLATIONS, DAY_OF_WEEK_TRANSLATIONS } from 'constants/reports';
import { ANALYTICS_EVENTS } from 'constants/mixpanel.constants';

import { FullWidthTableContent } from 'components/TableForm/styles';
import TableHeader from 'components/TableForm/Header';
import FlashMessage from 'components/FlashMessage';

import { Container, Relative, Modal, Header, Title, Close, Content, Footer } from 'styles/modals';
import { Row, Column } from 'styles/table';
import { ActionsContainer, ActionButton, CancelButton } from './styles';

const EmailReportRows = (props) => {
  const { onEditReport, onDeleteReport } = props;

  if (props.reports.size === 0) {
    return null;
  }

  const handleEditReport = (report) => () => {
    onEditReport(report);
  };

  const handleDeleteReport = (id) => () => {
    onDeleteReport(id);
  };

  const reports = props.reports.map((report) => {
    const frequencyObject = getRevertedCronString(report.get('schedule'));
    const dayOfWeekId = frequencyObject.dayOfWeek
      ? DAY_OF_WEEK_TRANSLATIONS[frequencyObject.dayOfWeek]
      : 'components.Modals.ManageReports.notApplicable';
    const dayOfMonth = frequencyObject.dayOfMonth ? (
      frequencyObject.dayOfMonth
    ) : (
      <FormattedMessage id="components.Modals.ManageReports.notApplicable" />
    );

    return (
      <Row key={`report-${report.get('id')}`}>
        <Column>{report.get('name')}</Column>
        <Column>
          <FormattedMessage id={TIME_TRANSLATIONS[frequencyObject.time]} />
        </Column>
        <Column>
          <FormattedMessage id={dayOfWeekId} />
        </Column>
        <Column>{dayOfMonth}</Column>
        <Column>
          <FormattedMessage id={FREQUENCY_TRANSLATIONS[frequencyObject.frequency]} />
        </Column>
        <Column>
          <ActionsContainer>
            <ActionButton onClick={handleEditReport(report)}>
              <FormattedMessage id="components.Modals.ManageReports.edit" />
            </ActionButton>
            <ActionButton onClick={handleDeleteReport(report.get('id'))}>
              <FormattedMessage id="components.Modals.ManageReports.delete" />
            </ActionButton>
          </ActionsContainer>
        </Column>
      </Row>
    );
  });

  return <tbody>{reports}</tbody>;
};

class ManageReports extends Component {
  state = {
    tableLabels: [
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.intl.formatMessage({
        id: 'components.Modals.ManageReports.name',
      }),
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.intl.formatMessage({
        id: 'components.Modals.ManageReports.time',
      }),
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.intl.formatMessage({
        id: 'components.Modals.ManageReports.dayOfWeek',
      }),
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.intl.formatMessage({
        id: 'components.Modals.ManageReports.dayOfMonth',
      }),
      // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.props.intl.formatMessage({
        id: 'components.Modals.ManageReports.frequency',
      }),
      '',
    ],

    flashMessageVisible: false,
    flashMessageType: null,
    flashMessage: null,
  };

  componentDidUpdate = (prevProps) => {
    // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (prevProps.visible !== this.props.visible && document.body) {
      // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
      if (this.props.visible) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }

      // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
      if (this.props.visible && prevProps.emailReports.size === 0) {
        prevProps.getEmailReports();
      }
    }
  };

  // Opens the edit recurring email modal
  handleEditReport = (report) => {
    // @ts-expect-error TS(2339): Property 'onEditReport' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.onEditReport(report);
  };

  // Deletes a report
  handleDeleteReport = (id) => {
    // @ts-expect-error TS(2339): Property 'deleteRecurringEmail' does not exist on ... Remove this comment to see the full error message
    this.props.deleteRecurringEmail(id);
  };

  // Closes the modal
  handleCloseModal = () => {
    // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (this.props.loading) {
      return;
    }

    // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.onCloseModal();
  };

  //=================================================
  //  Flash message related
  //=================================================

  // Opens the flash message
  handleOpenFlashMessage = (text, type) => {
    this.setState({
      flashMessageVisible: true,
      flashMessageType: type,
      flashMessage: text,
    });
  };

  // Closes the flash message
  handleCloseFlashMessage = () => {
    this.setState({
      flashMessageVisible: false,
      flashMessageType: null,
      flashMessage: null,
    });
  };

  render() {
    // @ts-expect-error TS(2339): Property 'visible' does not exist on type 'Readonl... Remove this comment to see the full error message
    if (!this.props.visible) {
      return null;
    }

    return (
      <Container>
        <FlashMessage
          visible={this.state.flashMessageVisible}
          type={this.state.flashMessageType}
          text={this.state.flashMessage}
          onClose={this.handleCloseFlashMessage}
        />

        <Relative>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Modal loading={this.props.loading}>
            <Header>
              <Title>
                <FormattedMessage id="components.Modals.ManageReports.title" />
              </Title>
              <Close
                onClick={() => {
                  // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
                  this.props.onCloseModal();
                  mixpanel.track(ANALYTICS_EVENTS.CLOSE_MODAL);
                }}
                className="icon-close-light"
              />
            </Header>

            <Content>
              <FullWidthTableContent>
                <TableHeader titles={this.state.tableLabels} />
                <EmailReportRows
                  // @ts-expect-error TS(2339): Property 'emailReports' does not exist on type 'Re... Remove this comment to see the full error message
                  reports={this.props.emailReports}
                  onEditReport={this.handleEditReport}
                  onDeleteReport={this.handleDeleteReport}
                />
              </FullWidthTableContent>
            </Content>

            <Footer>
              {/* @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message */}
              <CancelButton onClick={this.handleCloseModal} disabled={this.props.loading}>
                <FormattedMessage id="components.Modals.ManageReports.close" />
              </CancelButton>
            </Footer>
          </Modal>
        </Relative>
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  emailReports: selectEmailReports(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getEmailReports,
      deleteRecurringEmail,
    },
    dispatch
  );

// @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<FC<WithIntlPr... Remove this comment to see the full error message
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ManageReports)));
